import CryptoJS from 'crypto-js'
// 使用示例
// const encryptedData = '5Wbcawug_beHgA4G4yRMQpG-loRCSvqboE7EcyvA9rQylOB0dzn8whc-Fasmxsfraj8s0jEp_j5SkGI9fCLTyFmuPW2nNV8Vq55Cd4uIDXM' // 不带 padding 的 Base64Url
const secretKey = 'YourSecretKey123' // 16/24/32字节长度
export default{
     decryptBackendData(encryptedBase64Url) {
         try{
             // 1. 处理 Base64 URL 安全编码
             // 替换 URL 安全的 Base64 字符为标准 Base64 字符
             let base64 = encryptedBase64Url
                 .replace(/-/g, '+')
                 .replace(/_/g, '/')

             // 添加必要的 Base64 填充（因为后端使用了 withoutPadding）
             while (base64.length % 4 !== 0) {
                 base64 += '='
             }

             // 2. 将 Base64 字符串转换为 CryptoJS 格式
             const encryptedData = CryptoJS.enc.Base64.parse(base64)

             // 3. 准备密钥（直接使用 UTF-8 编码的密钥）
             const key = CryptoJS.enc.Utf8.parse(secretKey)

             // 4. 解密配置（ECB 模式，PKCS7 填充）
             const decrypted = CryptoJS.AES.decrypt(
                 { ciphertext: encryptedData },
                 key,
                 {
                     mode: CryptoJS.mode.ECB, // ECB 模式
                     padding: CryptoJS.pad.Pkcs7 // PKCS7 填充（等同于 Java 的 PKCS5）
                 }
             )

             // 5. 返回 UTF-8 字符串
             return decrypted.toString(CryptoJS.enc.Utf8)
         }catch(err){
             console.log(err)
         }

}

}





// try {
//     const decrypted = decryptBackendData(encryptedData, secretKey)
//     console.log('解密结果:', decrypted)
// } catch (error) {
//     console.error('解密失败:', error)
// }
